module.exports = __webpack_public_path__ + "img/climb-down.a0093187.svg";